var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 14.753v3.75h3.75l11.06-11.06-3.75-3.75L0 14.753zm17.71-10.21a.996.996 0 0 0 0-1.41L15.37.793a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z","fill":"currentColor","fillRule":"evenodd"}));
}

Edit.defaultProps = {"width":"18","height":"19","viewBox":"0 0 18 19"};

module.exports = Edit;

Edit.default = Edit;
